/**
 * @flow
 * @author: Manikanta
 */

export const GOOGLE_MAP_URL = `https://goo.gl/maps/3wczs3tvwRT2`

export const ANAMORA_MALL_URL = `https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7566.464100873733!2d73.93424831739591!3d18.518412999999992!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xaf17bb8c37c33c68!2siB+Cricket!5e0!3m2!1sen!2sin!4v1536120661865`

export const GOOGLE_MAP_EMBED_URL = `${ANAMORA_MALL_URL}&disable_scroll=true&t=m`

export const TESTIMONIALS_VIDEO_ID = `Hhq0I1jkMFg`

export const IS_BOOKING_SLOT_STRIRP_CLOSED = 'QWEeDmXxV24M0I2'

export const testimonialsContent = {
  presidentTestimonialHeading: 'President of India',
  presidentTestimonialContent:
    'Shri Ram Nath Kovind playing the first ball of iB Cricket'
}



// WEBPACK FOOTER //
// ./src/constants/IbcArcadeConstants.js